import React from 'react'
import { Card, Typography } from 'antd'

const { Title } = Typography

interface AuthLayoutProps {
  title: string
  subtitle?: React.ReactNode
  children: React.ReactNode
}

export function AuthLayout({ title, subtitle, children }: AuthLayoutProps) {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-[#f5f2ee] p-3 sm:p-4 md:py-8 overflow-hidden">
      <style>{`
        input:-webkit-autofill,
        input:-webkit-autofill:hover, 
        input:-webkit-autofill:focus, 
        input:-webkit-autofill:active {
          -webkit-box-shadow: 0 0 0 9999px white inset !important;
          -webkit-text-fill-color: #000000 !important;
          transition: background-color 5000s ease-in-out 0s;
        }
        input[type="password"]::-ms-reveal,
        input[type="password"]::-ms-clear {
          display: none;
        }
      `}</style>

      <div
        className="absolute inset-0 z-0 pointer-events-none opacity-[0.1]"
        style={{
          backgroundImage: 'url("/Vector.png")',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      />

      <Card className="relative z-10 w-full max-w-[480px] rounded-xl sm:rounded-2xl bg-white [&_.ant-card-body]:p-5 sm:[&_.ant-card-body]:p-8 shadow-sm">
        <div className="mb-4 sm:mb-6 text-center">
          <img
            src="/logo_tthcc 1.png"
            alt="Logo"
            className="mx-auto h-12 w-12 sm:h-16 sm:w-16 object-contain drop-shadow-sm"
          />
          <Title level={2} className="!m-0 !text-xl sm:!text-2xl">
            {title}
          </Title>
          {subtitle}
        </div>
        {children}
      </Card>
    </div>
  )
}
